import React from 'react';
import _RegisterBusinessForm from './_RegisterBusinessForm.scss';
import Recaptcha from 'react-recaptcha';
import {Link, withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {Input, Textarea} from 'components/vitrade-forms/common';
import {CategorySelectorInput} from 'components/vitrade-forms';
import {SingleImageUploader} from 'components/uploader';
import {Businesses} from 'api';
import {toastr} from 'react-redux-toastr';
import CONFIG from 'base/constants/config';

class RegisterBusinessForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.props.validators['formBusinessRegistration'] = [];

    this.state = {
      name: '',
      email: '',
      address: '',
      logo: '',
      geoLng: 0,
      geoLat: 0,
      taxCode: '',
      phone: '',
      description: '',
      agreeTOS: false,
      countryId: 0,
      categoryIds: []
    }
  }

  submitForm(e) {
    //do something
    e.preventDefault();

    if (this.validateSubmitForm()) {
      let {
        agreeTOS,
        ...data
      } = this.state;
      data['userId'] = this.props.auth.user.id;

      Businesses.actions.register.request({}, {data}).then(response => {
        toastr.success('Thành công!', 'Bạn đã đăng ký thành công. Thông tin doanh nghiệp của bạn cần được kiểm duyệt trước khi được đưa lên sàn. Bạn vui lòng đợi trong giây lát.');
        this.props.history.push('/my-businesses');
      }).catch(err => {
        console.log(err);
      });
    } else {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
    }

    return false;
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formBusinessRegistration'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
      }
    );

    if (!pass) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }

    return pass;
  }

  onChange(name, e) {
    this.setState({[name]: e.target.value})
  }

  toggleAgreeTOS() {
    this.setState({
      agreeTOS: !this.state.agreeTOS
    });
  }

  selectCategories(value) {
    let categoryIds = [];
    value.map(item => {
      categoryIds.push(item.value);
    });

    this.setState({categoryIds});
  }

  onUploadComplete(image) {
    this.setState({logo: image.name})
  }

  render() {
    return (
      <div className="register-business-box">
        <div className="register-logo">
          <b>Đăng ký thông tin doanh nghiệp</b>
        </div>
        <form onSubmit={this.submitForm.bind(this)}>
          <SingleImageUploader fnUpload={Businesses.actions.upload.request} onUploadComplete={this.onUploadComplete.bind(this)} image={this.state.logo}/>
          <div className="register-box-body">
            <Input type="text" placeholder="Tên công ty..." className='has-feedback fg-custom' iconClassName='fa-user-o' value={this.state.name} required={true} onChange={this.onChange.bind(this, 'name')} bindValidator={this} channel="formBusinessRegistration" errorMessage="Tên doanh nghiệp không được để trống"/>
            <Input type="email" placeholder="Email của doanh nghiệp..." className='has-feedback fg-custom' iconClassName='fa-at' value={this.state.email} onChange={this.onChange.bind(this, 'email')} required={true} bindValidator={this} channel="formBusinessRegistration" errorMessage="Bạn vui lòng cung cấp email"/>
            <Input type="text" placeholder="Địa chỉ..." className='has-feedback fg-custom' value={this.state.address} onChange={this.onChange.bind(this, 'address')} iconClassName='fa-map-marker' required={true} bindValidator={this} channel="formBusinessRegistration" errorMessage="Bạn vui lòng cung cấp email"/>
            <Input type="text" placeholder="Mã số thuế..." className='has-feedback fg-custom' value={this.state.taxCode} onChange={this.onChange.bind(this, 'taxCode')} iconClassName='fa-briefcase' required={true} bindValidator={this} channel="formBusinessRegistration" errorMessage="Bạn vui lòng cung cấp mã số thuế"/>
            <Input type="text" placeholder="Số điện thoại..." className='has-feedback fg-custom' iconFontSet='fa' iconClassName='fa-phone' value={this.state.phone} onChange={this.onChange.bind(this, 'phone')} required={true} bindValidator={this} channel="formBusinessRegistration" errorMessage="Bạn vui lòng cung cấp số điện thoại"/> {/* multiSelectBox */}
            <CategorySelectorInput label="Chọn lĩnh vực kinh doanh" data={this.state.categories} onChange={this.selectCategories.bind(this)}/>

            <Textarea type="text" placeholder="Mô tả..." className='fg-custom vitrade-textarea' iconFontSet='glyphicon' iconClassName='glyphicon-user' value={this.state.description} onChange={this.onChange.bind(this, 'description')} required={true} bindValidator={this} channel="formBusinessRegistration" errorMessage="Bạn vui lòng nhập mô tả ngắn"/>
            <div>
              <div className="checkbox term">
                <label>
                  <input type="checkbox" onChange={this.toggleAgreeTOS.bind(this)}/>
                  Tôi đồng ý với
                  <Link to='/cms/djieu-khoan-and-djieu-kien-giao-dich'>&nbsp;điều kiện sử dụng và chính sách của Vitrade</Link>
                </label>
              </div>
            </div>
            <div className="google-captcha">
              <Recaptcha sitekey={CONFIG.CAPTCHA_KEY}/>
            </div>
            <div>
              <button type="submit" disabled={!this.state.agreeTOS} className="btn btn-primary btn-block btn-flat btn-submit text-btn">ĐĂNG KÝ DOANH NGHIỆP</button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

RegisterBusinessForm.defaultProps = {
  validators: {}
}

const bindStateToProps = state => {
  return {auth: state.auth}
}

export default withRouter(connect(bindStateToProps)(RegisterBusinessForm));



// WEBPACK FOOTER //
// ./components/business/register-business-form/RegisterBusinessForm.jsx